import React from 'react';
import './Products.css'; // Import the CSS file
import './index.css'; // Import the CSS file


import phoneAnimation from './ocmfcVplZe.json';
import stealAnimation from './KmHk1GZV9o.json';

import Lottie from 'lottie-react';  // Not { Lottie }
import photo from './photo.jpg'; // Import the logo image
import social from './soc3.jpg'; // Import the logo image
import slide1 from './slide1.png'; // Import the logo image
import slide2 from './slide2.png'; // Import the logo image
import slide3 from './slide3.png'; // Import the logo image
import slide4 from './slide4.png'; // Import the logo image
import slide5 from './slide5.png'; // Import the logo image
import slide6 from './slide6.png'; // Import the logo image
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import gp from './gp.png';
import apps from './as.png';
import foodBack from './foodBack.png';

import { useState, useEffect } from 'react';

import { Button } from '@mui/material'; // Import Material-UI components
import buy from './buy.png';
import sub from './sub.png';


const Products = () => {
  const [isMobileWin, setIsMobileWin] = useState(window.innerWidth >= 1300);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileWin(window.innerWidth <= 900);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const handleRegisterClick = () => {
    window.scrollTo(0, 0); // Scroll to the very top-left of the page
    navigate('/contact'); // Navigate to /register
  };
  const navigate = useNavigate();

  return (
    <div className="productsContainer" >


      <div className="salesTextPort" >
        <div className="salesTextTop2">
          <h2 className="salesTitle">Customize every aspect of your app!</h2>
          <div className="salesParagraph">
            We want the your product to turn out exactly like you envisioned it. That is why we will work with you to design every single screen inside your application.
          </div>


          <Lottie
            animationData={phoneAnimation}
            loop={true} // Set to true to loop the animation
            className="prodLottie"
          />


        </div>
      </div>

      <div className="divider"></div>
      <div className="salesTextPort">
        <div className="salesTextTop2">
          <h2 className="salesTitle">Industry leading apps at the best possible price</h2>
          <div className="salesParagraph">
            Our incredibly efficient development process removes unnecessary costs, and we pass those savings onto your business.
            We have an amazing list of already available features. To start, simply choose which ones best fit your business! Have an idea for a new feature? Our development team will ensure that it comes to life!
          </div>
        </div>
      </div>




      {/* 
      <div className="salesTextPort">
        <div className="salesTextTop2">
          <h2 className="salesTitle">Want to add unique features?</h2>
          <div className="salesParagraph">
            Have an idea for a feature we don't already offer? Our development team will ensure that it comes to life!
          </div>
        </div>
      </div> */}


      <div className="divider"></div>

      <div>
        <div className="salesTextPort">
          <div className="salesTextTop2">
            <h2 className="salesTitle">Compatible with all devices!</h2>
            <p className="salesParagraph">
              We will release your unique app into both the App Store and the Google Play Store so you will be able to reach customers on iPhone and Android devices!
            </p>
          </div>
        </div>
      </div>

      {isMobile ? (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
          <img src={gp} alt="Google Play" className="storeImg" style={{ boxShadow: "0px 8px 12px rgba(0, 0, 0, 0.7)", borderRadius: '7.5px' }} />
          <img src={apps} alt="App Store" className="storeImg" style={{ boxShadow: "0px 8px 12px rgba(0, 0, 0, 0.7)", borderRadius: '7.5px' }} />
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
          <img src={gp} alt="Google Play" className="storeImg" style={{ boxShadow: "0px 8px 12px rgba(0, 0, 0, 0.7)", borderRadius: '10px' }} />
          <img src={apps} alt="App Store" className="storeImg" style={{ boxShadow: "0px 8px 12px rgba(0, 0, 0, 0.7)", borderRadius: '10px' }} />
        </div>
      )}



      <div className="salesTextPort">
        <div className="salesTextTop2">
          <h2 className="salesTitle">Optional Services</h2>
          <div className="salesParagraph">
            Need help getting the word out on social media about your app? How about taking high quality photos of your products? We offer the following services to help make your app stand out!
          </div>
        </div>
      </div>




      <div>
        {isMobile ? (
          // Mobile Layout
          <div
            style={{
              width: '100%',
              height: '450px',
              backgroundImage: `url(${foodBack})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderRadius: '0px',
              position: 'relative',
              padding: '0',
              gap: '0px'
            }}
          >
            <div
              style={{
                justifyContent: 'center',
                gap: '0px', // Reduced gap between images
                width: '90%',
                marginLeft: '5%',
                height: '100%',
              }}
            >
              {/* First Image */}
              <div style={{ width: '100%', height: '50%', position: 'relative' }}>
                <img
                  src={photo}
                  alt="social"
                  style={{
                    width: '100%',
                    height: '90%',
                    objectFit: 'cover',
                    borderRadius: '15px',
                    margin: '0 auto',
                    display: 'block',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.9)', // Adding the shadow
                  }}
                />

                <div
                  style={{
                    position: 'absolute',
                    bottom: '10%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: 'rgba(255, 255, 255, 1.0)',
                    padding: '7.5px 15px',
                    borderRadius: '15px',
                    color: '#336699',
                    fontSize: '1.5rem',
                    fontFamily: 'Medium',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    minWidth: '225px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  Photography
                </div>
              </div>

              {/* Second Image */}
              <div style={{ width: '100%', height: '50%', position: 'relative' }}>
                <img
                  src={social}
                  alt="social"
                  style={{
                    width: '100%',
                    height: '90%',
                    objectFit: 'cover',
                    borderRadius: '15px',
                    margin: '0 auto',
                    display: 'block',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.9)', // Adding the shadow
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    bottom: '10%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: 'rgba(255, 255, 255, 1.0)',
                    padding: '7.5px 15px',
                    borderRadius: '15px',
                    color: '#336699',
                    fontSize: '1.5rem',
                    fontFamily: 'Medium',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    minWidth: '225px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  Marketing
                </div>
              </div>
            </div>
          </div>

        ) : (
          // Desktop Layout
          <div
            style={{
              width: '100%',
              height: '600px',
              backgroundImage: `url(${foodBack})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderRadius: '0px',
              position: 'relative',
              padding: '0',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '20px',
                width: '100%',
                height: '100%',
              }}
            >
              {/* First Image */}
              <div className='serviceText' style={{ width: '48%', height: '100%', position: 'relative' }}>
                <img
                  src={photo}
                  alt="social"
                  style={{
                    width: '100%',
                    height: '82.5%',
                    objectFit: 'cover',
                    borderRadius: '12.5px',
                    margin: '0 auto',
                    display: 'block',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.9)', // Adding the shadow
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    bottom: '20%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: 'rgba(255, 255, 255, 1.0)',
                    padding: '10px 20px',
                    borderRadius: '12.5px',
                    color: '#336699',

                    fontFamily: 'Medium',
                    fontWeight: 'bold',
                    textAlign: 'center',

                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  Photography
                </div>
              </div>

              {/* Second Image */}
              <div style={{ width: '48%', height: '100%', position: 'relative' }}>
                <img
                  src={social}
                  alt="social"
                  style={{
                    width: '100%',
                    height: '82.5%',
                    objectFit: 'cover',
                    borderRadius: '12.5px',
                    margin: '0 auto',
                    display: 'block',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.9)', // Adding the shadow
                  }}
                />
                <div className='serviceText'
                  style={{
                    position: 'absolute',
                    bottom: '20%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: 'rgba(255, 255, 255, 1.0)',
                    padding: '10px 20px',
                    borderRadius: '15px',
                    color: '#336699',

                    fontFamily: 'Medium',
                    fontWeight: 'bold',
                    textAlign: 'center',

                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  Marketing
                </div>
              </div>
            </div>
          </div>
        )}
      </div>








      {isMobile ? (

        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
          <div className="whiteCard" style={{ padding: '10px', marginBottom: '20px' }}>
            <h2 className="salesTitleBlack" style={{ color: 'black', fontFamily: 'Medium' }}>
              Our Pricing Model
            </h2>

            <div
              className="salesParagraph"
              style={{
                display: 'inline-block',
                textAlign: 'center',
                width: '100%',
                color: 'black',
              }}
            >
              We know that every app is different, and we won't charge your business for unnecessary costs. That is why the exact price is based on 3 key factors.
            </div>

            {/* Left-aligned H2 tags */}
            <h2 style={{ textAlign: 'left', color: 'black', fontFamily: 'Medium', fontSize: '1.3rem', marginTop: '0px', marginBottom: '5px' }}>1. App Complexity</h2>
            <img src={slide1} alt="photo" style={{ width: '97%', marginTop: '0px', marginBottom: '0px' }} />

            <h2 style={{ textAlign: 'left', color: 'black', fontFamily: 'Medium', fontSize: '1.3rem', marginBottom: '5px' }}>2. Unique Features</h2>
            <img src={slide2} alt="photo" style={{ width: '97%', marginTop: '0px', marginBottom: '0px' }} />

            <h2 style={{ textAlign: 'left', color: 'black', fontFamily: 'Medium', fontSize: '1.3rem', marginBottom: '5px' }}>3. Number of Locations</h2>
            <img src={slide3} alt="photo" style={{ width: '97%', marginTop: '0px', marginBottom: '0px', }} />

            {/* <div
              className="salesParagraph"
              style={{
                display: 'inline-block',
                textAlign: 'center',
                width: '90%',
                color: 'black',
                margin: '0px'
              }}
            >
              Our quoting system guarantees you only pay for what your restaurant needs!
            </div> */}
            <div className="dividerBlack"></div>

            <h2 className="salesTitleBlack" style={{ color: 'black', fontFamily: 'Medium' }}>
              No Transaction Fees!
            </h2>
            <div
              className="salesParagraph"
              style={{
                display: 'inline-block',
                textAlign: 'center',
                width: '100%',
                color: 'black',
              }}
            >
              <Lottie
                animationData={stealAnimation}
                loop={true} // Set to true to loop the animation
                className="stealLottie"
              />
              Other companies take around a $0.50 fee on every transaction inside your app. Which can really cut into or even erase your profits for small ticket items.
            </div>
            <div className="dividerBlack"></div>
            <h2 className="salesTitleBlack" style={{ color: 'black', fontFamily: 'Medium' }}>
              Choose The Way You Pay
            </h2>
            <div
              className="salesParagraph"
              style={{
                display: 'inline-block',
                textAlign: 'center',
                width: '100%',
                color: 'black',
              }}
            >
              You can decide to pay a monthly subscription, buy the app upfront, or even do a mixture of both!
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
              <div style={{
                background: '#f5f5f5',
                boxShadow: '2px 4px 6px rgba(0, 0, 0, 0.8)',
                width: '100%',
                border: '1.5px solid black', // Black border
                borderRadius: '15px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '5px',
                boxSizing: 'border-box'
              }}>
                <img src={sub} alt="buy" style={{ width: '110px', height: '100px', marginTop: '5px', marginBottom: '0px' }} />
                <p style={{ marginTop: '5px', marginBottom: '10px', textAlign: 'center', fontFamily: 'Medium', fontSize: '1.5rem', color: '#336699' }}>Monthly Subscription</p>

                {/* Black Divider Above Price */}
                <div style={{ width: '100%', height: '2px', backgroundColor: 'black', marginTop: '00px' }}></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '10px' }}>
                  <div style={{ textAlign: 'left', color: 'black', fontFamily: 'Bold', fontSize: '1.05rem' }}>
                    Competitors: <del>$300 to $700 (with fees)</del>
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '5px' }}>
                  <div style={{ textAlign: 'left', color: '#336699', fontFamily: 'Bold', fontSize: '1.4rem' }}>
                    Our Price: <span style={{ color: '#9EE493', fontFamily: 'Bold', fontSize: '1.4rem' }}>$175 to $400</span>
                  </div>
                </div>
              </div>


              <div style={{
                background: '#f5f5f5',
                boxShadow: '2px 4px 6px rgba(0, 0, 0, 0.8)',
                width: '100%',
                border: '1.5px solid black', // Black border
                borderRadius: '15px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '5px',
                boxSizing: 'border-box'
              }}>
                <img src={buy} alt="buy" style={{ width: '100px', height: '100px', marginTop: '5px', marginBottom: '0px' }} />
                <p style={{ marginTop: '5px', marginBottom: '10px', textAlign: 'center', fontFamily: 'Medium', fontSize: '1.5rem', color: '#336699' }}>Purchase Upfront</p>

                {/* Black Divider Above Price */}
                <div style={{ width: '100%', height: '2px', backgroundColor: 'black', marginTop: '00px' }}></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '10px' }}>
                  <div style={{ textAlign: 'left', color: 'black', fontFamily: 'Bold', fontSize: '1.05rem' }}>
                    Competitors: <del>$8,000 to $25,000</del>
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '5px' }}>
                  <div style={{ textAlign: 'left', color: '#336699', fontFamily: 'Bold', fontSize: '1.4rem' }}>
                    Our Price: <span style={{ color: '#9EE493', fontFamily: 'Bold', fontSize: '1.4rem' }}>$3,500 to $10,000</span>
                  </div>
                </div>
              </div>

            </div>


            {/* Competitor price (only numbers crossed out) and our price */}
            {/* <div style={{ textAlign: 'left', color: 'black', fontFamily: 'Bold', marginTop: '10px', fontSize: '1.3rem' }}>
              Competitors: <del>$8,000 to $15,000</del>
            </div>
            <div style={{ textAlign: 'left', color: '#336699', fontFamily: 'Bold', fontSize: '1.3rem', marginTop: '10px', }}>
              Our Price: <span style={{ color: '#9EE493', fontFamily: 'Bold', fontSize: '1.3rem' }}>$3,500 to $7,500</span>
            </div> */}

            <h2 className="salesTitle" style={{ color: 'black', fontFamily: 'Medium', fontSize: '1.5rem' }}>
              Get a Free Quote Today!
            </h2>

            <Button onClick={handleRegisterClick} variant='contained' style={{ marginTop: '10px', marginBottom: '25px', backgroundColor: '#86BBD8', fontSize: '1.2rem', fontFamily: 'Medium' }}>Book Consultation</Button>
          </div>
        </div>

      ) : (
        <div style={{ marginTop: '20px', marginBottom: '0px' }}>
          <div className="whiteCard" style={{ padding: '20px' }}>
            <h2 className="salesTitleBlack" style={{ color: 'black', fontFamily: 'Medium' }}>
              Our Pricing Model
            </h2>
            <div
              className="salesParagraph"
              style={{
                display: 'inline-block',
                textAlign: 'center',
                width: '100%',
                color: 'black',
              }}
            >
              Our streamlined development process ensures we can give you the best possible price. We know that every app is different, and we don't want to charge you for unnecessary costs. That is why the exact price is based on 3 key factors.
            </div>

            {/* Left-aligned H2 tags */}
            <h2 style={{ textAlign: 'left', color: 'black', fontFamily: 'Medium', fontSize: '2.75rem', margin: '0px' }}>1. App Complexity</h2>
            <img src={slide4} alt="photo" style={{ width: '94%', marginTop: '5px', marginBottom: '35px' }} />

            <h2 style={{ textAlign: 'left', color: 'black', fontFamily: 'Medium', fontSize: '2.75rem', margin: '0px' }}>2. Unique Features</h2>
            <img src={slide5} alt="photo" style={{ width: '94%', marginTop: '5px', marginBottom: '35px' }} />

            <h2 style={{ textAlign: 'left', color: 'black', fontFamily: 'Medium', fontSize: '2.75rem', margin: '0px' }}>3. Number of Locations</h2>
            <img src={slide6} alt="photo" style={{ width: '94%', marginTop: '5px,' }} />

            {/* <div
              className="salesParagraph"
              style={{
                display: 'inline-block',
         
                textAlign: 'center',
                width: '85%',
                color: 'black',
                margin: '0px',
                marginBottom: '10px'
              }}
            >
              Our quoting system guarantees you only pay for what your restaurant needs!
            </div> */}

            <div className="dividerBlack"></div>
            <h2 className="salesTitleBlack" style={{ color: 'black', fontFamily: 'Medium' }}>
              No Transaction Fees!
            </h2>
            <div
              className="salesParagraph"
              style={{
                display: 'inline-block',
                textAlign: 'center',
                width: '100%',
                color: 'black',
              }}
            >
              <Lottie
                animationData={stealAnimation}
                loop={true} // Set to true to loop the animation
                className="stealLottie"
              />
              Other companies take around a $0.50 fee on every transaction inside your app. Which can really cut into or even erase your profits for small ticket items.
            </div>

            <div className="dividerBlack"></div>
            <h2 className="salesTitleBlack" style={{ color: 'black', fontFamily: 'Medium' }}>
              Choose The Way You Pay
            </h2>
            <div
              className="salesParagraph"
              style={{
                display: 'inline-block',
                textAlign: 'center',
                width: '100%',
                color: 'black',

              }}
            >
              You can decide to pay a monthly subscription, buy the app upfront, or even do a mixture of both!
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
              <div style={{
                background: '#f5f5f5',
                boxShadow: '2px 4px 6px rgba(0, 0, 0, 0.8)',
                width: '47%',

                border: '1.5px solid black', // Black border
                borderRadius: '20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '10px',
                boxSizing: 'border-box'
              }}>
                <img src={sub} alt="buy" style={{ width: '110px', height: '100px', marginTop: '5px', marginBottom: '0px' }} />
                <p style={{ marginTop: '5px', marginBottom: '10px', textAlign: 'center', fontFamily: 'Medium', fontSize: '1.8rem', color: '#336699' }}>Monthly Subscription</p>

                {/* Black Divider Above Price */}
                <div style={{ width: '100%', height: '2px', backgroundColor: 'black', marginTop: '00px' }}></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '10px' }}>
                  <div style={{ textAlign: 'left', color: 'black', fontFamily: 'Bold', fontSize: '1.5rem' }}>
                    Competitors: <del>$300 to $700 (with fees)</del>
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '5px' }}>
                  <div style={{ textAlign: 'left', color: '#336699', fontFamily: 'Bold', fontSize: '2rem' }}>
                    Our Price: <span style={{ color: '#9EE493', fontFamily: 'Bold', fontSize: '2rem' }}>$200 to $400</span>
                  </div>
                </div>
              </div>


              <div style={{
                background: '#f5f5f5',
                boxShadow: '2px 4px 6px rgba(0, 0, 0, 0.8)',
                width: '47%',
                border: '1.5px solid black',  // Black border
                borderRadius: '20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '10px',
                boxSizing: 'border-box'
              }}>
                <img src={buy} alt="buy" style={{ width: '100px', height: '100px', marginTop: '5px', marginBottom: '0px' }} />
                <p style={{ marginTop: '5px', marginBottom: '10px', textAlign: 'center', fontFamily: 'Medium', fontSize: '1.8rem', color: '#336699' }}>Purchase Upfront</p>

                {/* Black Divider Above Price */}
                <div style={{ width: '100%', height: '2px', backgroundColor: 'black', marginTop: '00px' }}></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '10px' }}>
                  <div style={{ textAlign: 'left', color: 'black', fontFamily: 'Bold', fontSize: '1.5rem' }}>
                    Competitors: <del>$8,000 to $25,000</del>
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '5px' }}>
                  <div style={{ textAlign: 'left', color: '#336699', fontFamily: 'Bold', fontSize: '2em' }}>
                    Our Price: <span style={{ color: '#9EE493', fontFamily: 'Bold', fontSize: '2rem' }}>$3,500 to $10,000</span>
                  </div>
                </div>
              </div>

            </div>



            <h2 className="salesTitle" style={{ color: 'black', fontFamily: 'Medium', fontSize: '2rem' }}>
              Get a Free Quote Today!
            </h2>
            <Button onClick={handleRegisterClick} variant='contained' style={{ marginTop: '15px', backgroundColor: '#86BBD8', fontSize: '1.25rem', fontFamily: 'medium' }}>Book Consultation</Button>
          </div>


        </div>
      )
      }


      <div>

      </div>


    </div >
  );
};

export default Products;
